import { token } from '@atlaskit/tokens';

import { useAiAgentStats } from '../hooks/useAiAgentStats';

import type { StatsModuleProps } from '@atlassian/mpac-widgets';

import AgentsStats from '../../../../assets/images/agents-stats-section.png';

export const useStatsSectionConfig = (): StatsModuleProps => {
  const { installs, teamsUsingAI } = useAiAgentStats();

  return {
    headerText: 'Rovo-powered apps are transforming how teams work',
    image: AgentsStats,
    bigStat: {
      stat: installs.toString(),
      statText: 'installs of Marketplace apps with Rovo modules',
      statColor: token('color.text.brand'),
      statSymbol: {
        symbolCharacter: '+',
        symbolCharacterColor: token('color.text.brand'),
      },
    },
    littleStats: [
      {
        stat: teamsUsingAI.toString(),
        statText: 'Customer reviews. Trusted by real teams to get work done',
        statColor: token('color.text.brand'),
        statSymbol: {
          symbolCharacter: '+',
          symbolCharacterColor: token('color.text.brand'),
        },
      },
      {
        stat: 'Every role',
        statText: 'from Project Managers to IT using Rovo-powered apps to work smarter',
        statColor: token('color.text.brand'),
      },
    ],
  };
};
